export * from './baThemeRun.directive';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/directives/baThemeRun/index.ts